import { render, staticRenderFns } from "./ClaimInsert.vue?vue&type=template&id=27219d08&scoped=true&"
import script from "./ClaimInsert.vue?vue&type=script&lang=js&"
export * from "./ClaimInsert.vue?vue&type=script&lang=js&"
import style0 from "./ClaimInsert.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ClaimInsert.vue?vue&type=style&index=1&id=27219d08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27219d08",
  null
  
)

export default component.exports